module.exports = __webpack_public_path__ + "img/index13.62fef4c4.png";